import { CancelToken } from 'axios';
import { objectType } from 'types';
import { BaseXHR } from 'utils/axios';

export const getBusinessPartnerApi = (params?: { bpAllocatedDebt: number }) =>
  BaseXHR.$get('b2b/v1/business-partner/detail', params);

export const getListingAllocatedDebt = (
  params: { name: string },
  config?: { cancelToken: CancelToken },
) => {
  return BaseXHR.$get(
    'b2b/v1/business-partner/listing-allowcated-debt',
    params,
    config,
  );
};

export const getDepositHistoryApi = params => {
  const newParam = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/order/deposits?' + newParam);
};

export const getCreditHistoryApi = params => {
  const newParam = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/order/credits?' + newParam);
};

export const getDepositHistoryExportApi = params => {
  const newParam = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/order/deposit-csv?' + newParam);
};

export const getCreditHistoryExportApi = params => {
  const newParam = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/order/credit-csv?' + newParam);
};

export const getAccountListBelongAgentApi = params =>
  BaseXHR.$get('b2b/v1/agency/my-agency', params);

export const updateAccountStatusApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/agency/change-status', data);

export const getTotalRevenueApi = (
  data: {
    type: 'agent' | 'business';
    date: string;
  },
  config: { cancelToken: CancelToken },
) => BaseXHR.$get('b2b/v1/order/revenue', data, config);
export const getBusinessPartnerBanlceApi = () =>
  BaseXHR.$post('b2b/v1/business-partner/banlce-info');

export const getTransactionHistoryApi = params => {
  const newParam = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/order/transactions?' + newParam);
};

export const getTransactionHistoryExportApi = params => {
  const newParam = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/order/penalty-csv?' + newParam);
};

export const exportTransactionCSV = params => {
  const newParam = new URLSearchParams(params);
  return BaseXHR.$get('b2b/v1/order/transactions-csv?' + newParam);
};
